export const ExperienceIds = {
  SCRUBS: 'scrubs',
};
